import React from 'react';

import { withStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';

import classes from './KpiPanel.module.css';

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white',
        color:           'black',
        fontSize:        theme.typography.pxToRem(12),
        border:          '1px solid grey',
        borderRadius:    '5px'
    }
}))(Tooltip);

const KpiPanel = ({
    title,
    data,
    type,
    information,
    kpiType,
    ...props
}) => {

    const getFaultTooltip = () => {
        return (
            <div>
                <div className={classes.FaultTooltipTitle}>{'Period Fault Occurences'}</div>
                <div className={classes.FaultTooltipText}><b>{'Current Period Faults: '}</b>{'The number of times in and out of fault within the specified time period. If a fault has gone in and out of fault three times within that time period, this counts as 3. If the fault has stayed in fault during the time period, then this would count as 1. The fault number is not always 1:1.'}</div>
                <div className={classes.FaultTooltipText}><b>{'Previous Period Fault Occurrences: '}</b>{'The same definition as above but for the previous time period.'}</div>
            </div>
        );
    };

    if (kpiType) {
        switch (kpiType) {
            case 'fault':
                information = getFaultTooltip();
                break;
            default:
                break;
        }
    }

    return (
        <Paper className={classes.KpiPanel}>
            <div className={classes.Title}>
                {title}
                <div className={classes.Icon}>
                    <HtmlTooltip
                        title={
                            <span className={classes.Tooltip}>
                                {information}
                            </span>
                        }
                        placement="top-start"
                    >
                        <span><i className="fas fa-info-circle" /></span>
                    </HtmlTooltip>
                </div>
            </div>
            <div className={classes.ItemContainer}>
                {data.map((item, index) =>
                    <div key={index} className={classes.Item}>
                        <div className={index === 1 && type === 'score' ? classes.MinorValue : classes.Value }>
                            {item.value === 0 ? 0 : item.value || '-'}
                            {item.value && index === 1 && type === 'score' ?
                                <img className={classes.ChangeIcon} src={item.icon} alt="" />
                                :
                                ''
                            }
                        </div>
                        <div className={classes.Label}>
                            {item.label}
                        </div>
                    </div>
                )}
            </div>
        </Paper>
    );
};

export default KpiPanel;
